<template>
  <div>
    <div class="formTableContainer mt-3">
      <div v-for="key in zusatzfelderKeys" :key="key">
        <p>{{ key }} = {{ serviceKleberProperties.Zusatzfelder[key] }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "servicekleberProperties",
  data: function() {
    return {
      serviceKleberProperties: {},
      zusatzfelderKeys: []
    };
  },
  mounted() {
    this.loadProperties();
  },
  methods: {
    async loadProperties() {
      for (let propertiesEntry of this.properties) {
        if (
          this.servicekleber.data.extRef ===
          propertiesEntry[this.propertiesForeignKey]
        ) {
          this.servicekleber.properties = propertiesEntry;
          this.serviceKleberProperties = propertiesEntry;
          for (let key in propertiesEntry.Zusatzfelder) {
            this.zusatzfelderKeys.push(key);
          }
        }
      }
    }
  },
  props: {
    servicekleber: Object,
    propertiesForeignKey: String,
    properties: Object
  }
};
</script>
